import { OutsourceOrder } from "../../../data/entities";
import { OUTSOURCE_ORDER_STATUS, ROLE } from "../../../data/enums";
import { OUTSOURCE_ORDER_EXPORT_ROLES } from "../../../configs/outsourceOrderPermissions";

export type OutsourceOrderActionState = {
    canCancel: boolean;
    canEdit: boolean;
    canSendToStorage: boolean;
    canExport: boolean;
    canReceive: boolean;
    canComplete: boolean;
    canDownloadExport: boolean;
    canDownloadOrder: boolean;
    isSendToStorageDisabled: boolean;
    isExportDisabled: boolean;
};

const canManageOpenOrderRoles = [ROLE.MANAGER, ROLE.LOGISTIC_STAFF, ROLE.PURCHASING_STAFF];
const canOperateStorageRoles = [
    ROLE.MANAGER,
    ROLE.PURCHASING_STAFF,
    ROLE.STORAGE_KEEPER,
    ROLE.FIRST_STORAGE_KEEPER,
    ROLE.SECOND_STORAGE_KEEPER,
];

export const getOutsourceOrderActions = ({
    role,
    order,
    isExported,
    hasSourceMaterialShortage = false,
}: {
    role: ROLE;
    order: OutsourceOrder;
    isExported: boolean;
    hasSourceMaterialShortage?: boolean;
}): OutsourceOrderActionState => {
    const status = order?.status;
    const isOpen = status === OUTSOURCE_ORDER_STATUS.OPEN;
    const isExporting = status === OUTSOURCE_ORDER_STATUS.EXPORTING;
    const isPartiallyReturned = status === OUTSOURCE_ORDER_STATUS.PARTIALLY_RETURNED;
    const isCompleted = status === OUTSOURCE_ORDER_STATUS.COMPLETED;
    const canManageOpenOrder = canManageOpenOrderRoles.includes(role);
    const canOperateStorage = canOperateStorageRoles.includes(role);
    const canExportFromStorage = OUTSOURCE_ORDER_EXPORT_ROLES.includes(role);

    return {
        canCancel: canManageOpenOrder && (isOpen || isExporting) && !isExported,
        canEdit: canManageOpenOrder && isOpen,
        canSendToStorage: canManageOpenOrder && isOpen,
        canExport: canExportFromStorage && isExporting && !isExported,
        canReceive: false,
        canComplete: canOperateStorage && ((isExporting && isExported) || isPartiallyReturned),
        canDownloadExport: isCompleted,
        canDownloadOrder: canManageOpenOrder,
        isSendToStorageDisabled: !Array.isArray(order?.materials) || order.materials.length === 0,
        isExportDisabled: hasSourceMaterialShortage,
    };
};
